export default __webpack_public_path__ + "static/media/op-ku-logotype-d.1b503b97.svg";